import { ReactSelectStyles } from '../../types'
import customTheme from '../../../../../tailwind.config.js'

export function styles<T>(
  touched?: boolean,
  error?: string | boolean
): ReactSelectStyles<T> {
  return {
    option: (provided, { isFocused, isSelected }) => ({
      ...provided,
      fontSize: '0.875rem',
      background: isSelected ? '#F2F2F2' : isFocused ? '#F2F2F2' : undefined,
      color: isSelected ? '#595959' : '#595959',
      ':hover': {
        ...provided[':hover'],
        background: '#F2F2F2',
        cursor: 'pointer'
      }
    }),
    control: (provided, { isFocused }) => ({
      ...provided,
      fontSize: '0.875rem',
      fontWeight: 500,
      color: '#DB3333',
      boxShadow: isFocused
        ? `0 0 0 0.15rem ${
            touched && error ? 'rgb(220 53 69 / 25%)' : '#c9c9c9'
          }`
        : '0 0 0 1px rgb(172,172,172,1)',
      borderColor: touched && error ? '#DB3333' : '#ACACAC',
      borderRadius: 16,
      fontFamily: customTheme.theme.fontFamily.workSans.toString(),
      ':hover': {
        borderColor: touched && error ? '#DB3333' : '#ACACAC'
      },
      borderWidth: 0,
      letterSpacing: '-0.9px'
    }),
    dropdownIndicator: provided => ({
      ...provided,
      padding: '4px'
    }),
    valueContainer: provided => ({
      ...provided,
      paddingLeft: '16px',
      paddingTop: '4px',
      paddingBottom: '4px'
    }),
    singleValue: provided => ({
      ...provided,
      fontWeight: 500,
      color: customTheme.theme.colors.v3.gray['500']
    }),
    placeholder: provided => ({
      ...provided,
      color: '#ACACAC',
      fontWeight: 500
    }),
    menuList: provided => ({
      ...provided,
      borderRadius: 16
    }),
    menu: provided => ({
      ...provided,
      borderRadius: 16
    })
  }
}
